export const DATE = 'date'
export const NAME = 'name'
export const ROLE = 'role'
export const STATUS = 'status'
export const ACTION = 'action'
export const REASONS = 'reasons'
export const LABELS = {
  [DATE]: 'Date',
  [NAME]: 'Name',
  [ROLE]: 'Responsible',
  [STATUS]: 'Status',
  [ACTION]: 'Action',
  [REASONS]: 'Comments'
}
